module.exports = __webpack_public_path__ + "img/partnerprocess.b17efab5.png";